<script>
	export let onClick;
	export let onKeyDown;
</script>

<button
	style="border: none; background-color: transparent;"
	on:click={onClick}
	on:keydown={onKeyDown}
>
	<slot />
</button>
